import { getCookie, setCookie, deleteCookie } from "@/libraries/VueMethods";
export function cleanExpiredTorobItems() {
  const TOROB_COOKIE_NAME = "torobProductClicks";
  const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
  //   const SEVEN_DAYS_MS = 10 * 1000;
  const cookie = getCookie(TOROB_COOKIE_NAME);
  if (!cookie) return [];

  try {
    const now = Date.now();
    let torobProducts = JSON.parse(cookie);

    // فیلتر کردن محصولاتی که کمتر از 7 روز از عمرشان گذشته
    const validProducts = torobProducts.filter((item) => {
      return now - item.created_at < SEVEN_DAYS_MS;
    });

    if (validProducts.length === 0) {
      deleteCookie(TOROB_COOKIE_NAME);
      //   return [];
    } else if (validProducts.length !== torobProducts.length) {
      // فقط اگر تغییری در لیست ایجاد شده (حذفیات داشتیم)، کوکی را آپدیت کن
      setCookie(TOROB_COOKIE_NAME, JSON.stringify(validProducts), 7);
    }

    // return validProducts;
  } catch (e) {
    deleteCookie(TOROB_COOKIE_NAME);
    // return [];
  }
}
